import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import PlusIcon from "@material-ui/icons/Add";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 0,
    padding: 0,
    marginRight: 17,
  },
  buttonContainer: {
    minWidth: 30,
  },
  buttonStyle: {
    color: theme.palette.primary.main,
  },
  iconContainer: {
    minWidth: 25,
  },
  iconStyle: {
    width: 18,
    height: 18,
    color: theme.palette.primary.main,
  },
  listExpandStyle: {
    borderBottom: theme.shape.borderMedium,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: 14,
    marginBottom: 0,
    paddingBottom: 5,
  },
  listStyle: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: 14,
    marginBottom: 0,
    paddingBottom: 5,
  },
  nestedStyle: {
    padding: "0 0 0 35px",
    alignItems: "stretch",
    display: "flex",
    flexDirection: "column",
  },
}));

export default function ListGroup(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  const expandButton = open ? (
    <ExpandLess onClick={handleClick} className={classes.buttonStyle} />
  ) : (
    <ExpandMore onClick={handleClick} className={classes.buttonStyle} />
  );
  const canExpand = (
    <div>
      <ListItem onClick={handleClick} className={classes.root}>
        <ListItemIcon className={classes.buttonContainer}>
          {expandButton}
        </ListItemIcon>
        <ListItemText
          disableTypography
          className={classes.listExpandStyle}
          primary={props.title}
        />
      </ListItem>
      <Collapse in={open}>
        <List component="div" disablePadding>
          <ListItem className={classes.nestedStyle}>{props.children}</ListItem>
        </List>
      </Collapse>
    </div>
  );
  return (
    <div>
      {props.canExpand === true ? (
        canExpand
      ) : (
        <ListItem className={classes.root}>
          <ListItemIcon className={classes.iconContainer}>
            <PlusIcon className={classes.iconStyle} />
          </ListItemIcon>
          <ListItemText
            disableTypography
            className={classes.listStyle}
            primary={props.title}
          />
        </ListItem>
      )}
    </div>
  );
}

ListGroup.propTypes = {
  canExpand: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

ListGroup.defaultProps = {
  canExpand: false,
  children: undefined,
};
